import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BreadcrumbSection() {
  return <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-1927">
      <a href="/EDMNetwork.html" className="hover:text-orange transition-colors" data-id="element-1928">
        EDM Network
      </a>
      <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-1929" />
      <span className="text-navy font-semibold" data-id="element-1930">Sinker EDM</span>
    </div>;
}